import React from "react";
import AdjuntoEntrada from "../bitacora/AdjuntoEntrada";

/**
 * When `excluidos` (Set of idAdjunto) and `onToggleAdjunto` are passed, each
 * image gets a checkbox so the user can pick which ones go in the report.
 */
// seccion: "todo" (images then summary), "resumen" or "imagenes" so the
// report can show the summary first and the images at the end.
const ReporteContenido = ({
  seccion = "todo",
  reporte,
  fetching,
  onGenerar,
  excluidos,
  onToggleAdjunto,
  onSetAllAdjuntos,
}) => {
  const selectable = excluidos instanceof Set && typeof onToggleAdjunto === "function";

  const isRenderable = (Adjunto) => {
    if (!Adjunto) return false;
    const tipo = String(Adjunto.tipo || "").toLowerCase();
    if (["jpg", "jpeg", "png", "gif", "webp"].includes(tipo)) return true;
    if (tipo.includes("video")) return true;
    return false;
  };

  const renderImagenes = () => {
    if (!Array.isArray(reporte?.entradas)) return null;
    const adjuntos = reporte.entradas
      .filter(({ Adjunto }) => isRenderable(Adjunto))
      .map(({ Adjunto }) => Adjunto);
    if (!selectable) {
      return adjuntos.map((Adjunto) => (
        <AdjuntoEntrada key={Adjunto.idAdjunto} adjunto={Adjunto} />
      ));
    }
    if (adjuntos.length === 0) return null;
    const incluidas = adjuntos.filter((a) => !excluidos.has(a.idAdjunto)).length;
    return (
      <>
        <div className="d-flex align-items-center flex-wrap gap-2 mb-2 no-print">
          <span className="small text-muted me-2">
            {incluidas} de {adjuntos.length} imágenes incluidas
          </span>
          {typeof onSetAllAdjuntos === "function" && (
            <>
              <button
                type="button"
                className="btn btn-sm btn-outline-primary"
                onClick={() => onSetAllAdjuntos(true)}
              >
                Seleccionar todas
              </button>
              <button
                type="button"
                className="btn btn-sm btn-outline-secondary"
                onClick={() => onSetAllAdjuntos(false)}
              >
                Ninguna
              </button>
            </>
          )}
        </div>
        {adjuntos.map((Adjunto) => {
          const incluida = !excluidos.has(Adjunto.idAdjunto);
          return (
            <div
              key={Adjunto.idAdjunto}
              className="d-inline-block position-relative"
              style={{ opacity: incluida ? 1 : 0.35 }}
            >
              <input
                type="checkbox"
                className="form-check-input position-absolute"
                style={{ top: 6, left: 6, zIndex: 2, width: 20, height: 20 }}
                checked={incluida}
                title={incluida ? "Excluir del reporte" : "Incluir en el reporte"}
                onChange={() => onToggleAdjunto(Adjunto.idAdjunto)}
              />
              <AdjuntoEntrada adjunto={Adjunto} />
            </div>
          );
        })}
      </>
    );
  };

  const renderResumen = () => {
    if (fetching) {
      return (
        <span>
          <div className="spinner-border small me-2" /> Arqvisor Bot esta
          generando el resumen del período seleccionado...
        </span>
      );
    }
    const resumen = reporte?.resumen;
    if (!resumen) {
      return (
        <span className="text-muted fst-italic">
          Haz click en Generar Reporte para hacer un resumen con IA
        </span>
      );
    }
    // The AI may append a "Retrasos:" section after the regular bullets; it
    // sometimes writes the heading as a bullet ("- Retrasos:") or in bold.
    const [general, retrasos] = String(resumen).split(
      /^\s*(?:-\s*)?\**\s*Retrasos\s*:?\s*\**\s*$/im
    );
    const toItems = (text) =>
      String(text || "")
        .split(/\s*-\s+/)
        .map((s) => s.trim())
        .filter(Boolean);
    const renderItems = (text) => {
      const items = toItems(text);
      if (items.length === 0) return null;
      if (items.length === 1 && !/^\s*-\s+/.test(text)) {
        return <p className="resumen mb-0">{String(text).trim()}</p>;
      }
      return (
        <ul className="resumen mb-0 ps-3">
          {items.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      );
    };
    return (
      <>
        {renderItems(general)}
        {retrasos !== undefined && toItems(retrasos).length > 0 && (
          <>
            <p className="bold text-danger mt-3 mb-1">Retrasos</p>
            {renderItems(retrasos)}
          </>
        )}
      </>
    );
  };

  const celda = { wordBreak: "break-word", overflowWrap: "anywhere" };

  const filasImagenes = (
    <tr className="border">
      <td style={celda}>{renderImagenes()}</td>
    </tr>
  );

  const filasResumen = (
    <>
      <tr className="border text-white bold bg-primary">
        <td>RESUMEN</td>
      </tr>
      <tr className="border">
        <td style={celda}>{renderResumen()}</td>
      </tr>
    </>
  );

  // Not a .row: printing keeps .row blocks unbroken, which pushed a long
  // summary to the next page and left the first one empty.
  return (
    <div className="mx-0 reporte-contenido">
      <table className="table" style={{ tableLayout: "fixed", width: "100%" }}>
        <tbody>
          {seccion !== "resumen" && filasImagenes}
          {seccion !== "imagenes" && filasResumen}
        </tbody>
      </table>
    </div>
  );
};

export default ReporteContenido;
